import "./index.css";
import { Tooltip } from "react-tooltip";
import { Text } from "@chakra-ui/react";

interface FlightMarkerProps {
  icon: URL;
  direction: number;
  planeModel: string;
}

function FlightMarker({ direction, icon, planeModel }: FlightMarkerProps) {
  return (
    <>
      <div
        className={`flight-marker ${
          icon.toString().includes("santa") ? "santa" : ""
        }`}
        style={{
          backgroundImage: `url(${icon.toString()})`,
          transform: `rotate(${direction}deg)`,
        }}
        data-tooltip-id="flight-marker-tooltip"
      ></div>
      <Tooltip
        id="flight-marker-tooltip"
        render={() => (
          <Text fontSize="12px" color="white">
            {planeModel}
          </Text>
        )}
      />
    </>
  );
}

export default FlightMarker;
